import { WorkOrderStatus } from "@/gql/graphql";
import { BadgeColor } from "@/components/catalyst/badge";

export const workOrderStatusMap: Record<WorkOrderStatus, BadgeColor> = {
  [WorkOrderStatus.Archived]: "purple",
  [WorkOrderStatus.Invoiced]: "blue",
  [WorkOrderStatus.Completed]: "sky",
  [WorkOrderStatus.QuoteIssued]: "violet",
  [WorkOrderStatus.QuoteRejected]: "red",
  [WorkOrderStatus.QuoteRequested]: "zinc",
  [WorkOrderStatus.AssigningDrivers]: "yellow",
  [WorkOrderStatus.DriversAssigned]: "emerald",
  [WorkOrderStatus.InProgress]: "green",
};
